import { useController, type Control } from 'react-hook-form';
import { Masks, useMaskedInputProps } from 'react-native-mask-input';

export type MaskedControllerProps = {
  control: Control<any>;
  setFormValue: (value: any) => void;
  type: 'mobilePhone' | 'cardNumber' | 'cardExpiration';
};

const getMask = (type: MaskedControllerProps['type']) => {
  switch (type) {
    case 'mobilePhone':
      return Masks.USA_PHONE;

    case 'cardNumber':
      return Masks.CREDIT_CARD;

    case 'cardExpiration':
      return [/\d/, /\d/, ' / ', /\d/, /\d/];
  }
};

export function useMaskedController({ control, setFormValue, type }: MaskedControllerProps) {
  const controller = useController({
    name: type,
    control,
  });

  const inputProps = useMaskedInputProps({
    value: controller.field.value,
    onChangeText: (_masked: string, unmasked: string) => {
      controller.field.onChange(unmasked);

      setFormValue(unmasked);
    },
    mask: getMask(type),
  });

  return { controller, inputProps, value: controller.field.value };
}
